jQuery.feature_import("js-rect-maintenance-page",
  () => import("./maintenance_page.js"),
  mod => mod.feature_js_rect_maintenance_page
);